import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Provider from "pubsub-js";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import NoSsr from "@material-ui/core/NoSsr";
import FileCopyIcon from "@material-ui/icons/FileCopyOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutline";
import ClipboardIcon from "../../../../icons/ClipboardIcon";
import {systemMenu} from "../../constants/edit-menu";
import withSelectionContext from "../../decorators/withSelectionContext";
import {HAS_COPIED_OBJECT, CANVAS_MODIFIED} from "../../constants/event-types";
import {withStyles} from "@material-ui/core/styles";
import {conditionSelector} from "../../selectors";
import productSettings from "../../services/product-settings";

const styles = {
  root: {
    borderRadius: `3px`
  }
};

class System extends Component {
  static propTypes = {
    toggleEffect: PropTypes.func,
    condition: PropTypes.object,
    selected: PropTypes.object,
    classes: PropTypes.object
  };
  state = {
    hasCopiedObject: false,
    disabledPasteButton: false
  };
  getIcon(icon) {
    switch (icon) {
      case `copy`:
        return <FileCopyIcon />;
      case `clipboard`:
        return <ClipboardIcon />;
      case `trash`:
        return <DeleteIcon style={{color: `#cd7779`}} />;
    }
    return void 0;
  }
  componentDidMount() {
    Provider.subscribe(HAS_COPIED_OBJECT, this.setStateOfCopiedObject);
    Provider.subscribe(CANVAS_MODIFIED, this.handleDisabled);
  }
  componentWillUnmount() {
    Provider.unsubscribe(HAS_COPIED_OBJECT, this.setStateOfCopiedObject);
    Provider.unsubscribe(CANVAS_MODIFIED, this.handleDisabled);
  }
  setStateOfCopiedObject = () => {
    this.setState({
      hasCopiedObject: true,
      disabledPasteButton: true
    });
  };
  handleDisabled = () => {
    const {
      condition: {product, side}
    } = this.props;
    const settings = productSettings[product];
    const disabled =
      settings &&
      settings.permissions &&
      settings.permissions[side] &&
      !settings.permissions[side].image &&
      !settings.permissions[side].text;

    this.setState({
      disabledPasteButton: this.state.hasCopiedObject && !disabled
    });
  };
  render() {
    const {disabledPasteButton} = this.state;
    const {selected, classes} = this.props;
    return (
      <NoSsr>
        {systemMenu.map((itemMenu) => {
          const {name, hotKey, icon, handleClick} = itemMenu;
          const isShow =
            !!selected || (icon === `clipboard` && disabledPasteButton);
          return (
            isShow && (
              <div key={name} className="panel-control__item">
                <Tooltip title={`${name} ${hotKey}`}>
                  <div>
                    <IconButton
                      onClick={handleClick}
                      disabled={
                        icon === `clipboard` ? !disabledPasteButton : false
                      }
                      classes={{root: classes.root}}
                    >
                      {this.getIcon(icon)}
                    </IconButton>
                  </div>
                </Tooltip>
              </div>
            )
          );
        })}
      </NoSsr>
    );
  }
}

export default connect((state) => ({
  condition: conditionSelector(state)
}))(withSelectionContext(withStyles(styles)(System)));
